module.exports = __webpack_public_path__ + "static/media/img002.3bdad33a.jpg";